var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 29.4999C23.0736 30.9352 24.4434 32.1229 26.0164 32.9823C27.5894 33.8417 29.3288 34.3527 31.1166 34.4807C32.9045 34.6088 34.699 34.3508 36.3784 33.7244C38.0578 33.0979 39.5828 32.1176 40.85 30.8499L48.35 23.3499C50.627 20.9924 51.8869 17.8349 51.8584 14.5574C51.83 11.2799 50.5153 8.14478 48.1977 5.82718C45.8801 3.50958 42.745 2.19497 39.4675 2.16649C36.1901 2.13801 33.0325 3.39794 30.675 5.67491L26.375 9.94991M32 24.4999C30.9264 23.0646 29.5566 21.877 27.9836 21.0176C26.4107 20.1582 24.6712 19.6471 22.8834 19.5191C21.0955 19.391 19.301 19.649 17.6216 20.2755C15.9423 20.9019 14.4172 21.8822 13.15 23.1499L5.65001 30.6499C3.37304 33.0074 2.11311 36.165 2.14159 39.4424C2.17007 42.7199 3.48468 45.855 5.80228 48.1726C8.11988 50.4902 11.255 51.8049 14.5325 51.8333C17.81 51.8618 20.9675 50.6019 23.325 48.3249L27.6 44.0499",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.de09ea45433b572ced74f1911a961a68.svg";
export { ForwardRef as ReactComponent };